import React, { useState } from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Blocks from "../../blocks/_Blocks"

const TabFolderBlock = ({ block }) => {
  const [activeTabState, setActiveTabState] = useState(1)
  return (
    <BlockWrapper block={block} showHeadline="true">
      <nav className="mx-0.5 mt-8">
        {block.folder_items &&
          block.folder_items.length > 0 &&
          block.folder_items.map((item, index) => (
            <button
              key={index}
              className={`inline-block py-2 font-bold border-2 border-ro-gray-50 px-grid hover:bg-ro-gray-100 hover:border-ro-gray-100 ${
                activeTabState === index + 1
                  ? "bg-ro-gray-50 border-ro-gray-50"
                  : ""
              } -ml-0.5`}
              onClick={() => setActiveTabState(index + 1)}
              active
            >
              {item.title}
            </button>
          ))}
      </nav>
      <div className="relative w-full bg-ro-gray-50">
        {block.folder_items &&
          block.folder_items.length > 0 &&
          block.folder_items.map((item, index) => (
            <div
              key={index}
              className={`${
                activeTabState === index + 1 ? "block" : "hidden"
              } `}
            >
              {item.content &&
                item.content.map((content) =>
                  React.createElement(Blocks(content.component), {
                    key: content._uid,
                    block: content,
                    type: content.component,
                  })
                )}
            </div>
          ))}
      </div>
    </BlockWrapper>
  )
}

export default TabFolderBlock
